import { render, staticRenderFns } from "./LegalInfoPageList.vue?vue&type=template&id=ef89ad2a&"
import script from "./LegalInfoPageList.vue?vue&type=script&lang=js&"
export * from "./LegalInfoPageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports